import { Component, Input, OnInit } from '@angular/core';
import { GridCell } from '../../../models/sections-model';

@Component({
  selector: 'kw-product-price',
  templateUrl: './product-price.component.html',
  styleUrls: ['./product-price.component.scss']
})
export class ProductPriceComponent implements OnInit {
  @Input() gridCell:GridCell;
  
  constructor() { }

  ngOnInit(): void {
  }

}
